<template>
    <div class="ServicesDisplay">
        <a href="#" v-scroll-to="'#section-one'">
            <span class="mobileCard">
                <EngineeringIcon size="7vw" fillColor="var(--primary-color)"/>
            </span>
        </a>
        <a href="#" v-scroll-to="'#section-two'">
            <span class="mobileCard">
                <WorkSolutionsIcon size="7vw" fillColor="var(--primary-color)"/>
            </span>
        </a>
        <a href="#" v-scroll-to="'#section-three'">
            <span class="mobileCard">
                <EcommerceIcon size="7vw" fillColor="var(--primary-color)"/>
            </span>
        </a>
        <a href="#" v-scroll-to="'#section-four'">
            <span class="mobileCard">
                <AnalyticsIcon size="7vw" fillColor="var(--primary-color)"/>
            </span>
        </a>
    </div>
</template>

<script>

import AnalyticsIcon from '../custom_svgs/AnalyticsIcon.vue';
import EcommerceIcon from '../custom_svgs/EcommerceIcon.vue';
import EngineeringIcon from '../custom_svgs/EngineeringIcon.vue';
import WorkSolutionsIcon from '../custom_svgs/WorkSolutionsIcon.vue';

export default ({
    name: 'ServicesDisplay',
    components: {
        AnalyticsIcon,
        EcommerceIcon,
        EngineeringIcon,
        WorkSolutionsIcon
    },
    setup() {

    },
    created() {
    },
    data() {
        return {
        };
    },
    methods: {
    }
})
</script>

<style scoped>

.solutionCard {
    display: inline-block;
    margin-inline-end: 5vw;
    margin-inline-start: 5vw;
}

.solutionCard a {
    color: var(--primary-color);
}

.mobileCard {
    display: inline-block;
    margin-inline-start: 2vw;
    margin-inline-end: 2vw;
    padding: 5vw;
    border-radius: 15px;
    box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.2);
}

</style>